export const FETCH_OUTAGE_LIST_IN_PROGRESS = "FETCH_OUTAGE_LIST_IN_PROGRESS";
export const FETCH_OUTAGE_LIST_SUCCESS = "FETCH_OUTAGE_LIST_SUCCESS";
export const FETCH_OUTAGE_LIST_FAILED = "FETCH_OUTAGE_LIST_FAILED";

export const FETCH_OUTAGE_CONTEXT_IN_PROGRESS = "FETCH_OUTAGE_CONTEXT_IN_PROGRESS";
export const FETCH_OUTAGE_CONTEXT_SUCCESS = "FETCH_OUTAGE_CONTEXT_SUCCESS";
export const FETCH_OUTAGE_CONTEXT_FAILED = "FETCH_OUTAGE_CONTEXT_FAILED";

export const RESET_SELECTED_OUTAGE = "RESET_SELECTED_OUTAGE";
